export default "__VITE_ASSET__9998f8dc__"